// Presentation-side reading of a section body's GFM tables: header labels, row labels and
// [tokens] the page can offer as choices. Every choice is validated by the tool that receives it.

export interface SectionTable {
  header: string[];
  rows: string[][];
}

const SEPARATOR_PATTERN = /^\|(\s*:?-{3,}:?\s*\|)+\s*$/;
const TOKEN_PATTERN = /!?\[([^[\]\n]+)\](\()?/g;
const PHOTO_TOKEN = '[photo]';

export function cleanCell(cell: string): string {
  return cell
    .replace(/\*\*|__/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/:$/, '')
    .trim();
}

function splitCells(line: string): string[] {
  return line
    .trim()
    .split('|')
    .slice(1, -1)
    .map((cell) => cell.trim());
}

export function parseSectionTables(body: string): SectionTable[] {
  const lines = body.split('\n');
  const tables: SectionTable[] = [];
  let start = -1;
  const flush = (end: number): void => {
    if (start === -1) return;
    const block = lines.slice(start, end);
    if (block.length >= 2 && SEPARATOR_PATTERN.test(block[1].trim())) {
      tables.push({ header: splitCells(block[0]), rows: block.slice(2).map(splitCells) });
    }
    start = -1;
  };
  for (let i = 0; i <= lines.length; i += 1) {
    const isPipeLine = i < lines.length && lines[i].trim().startsWith('|');
    if (isPipeLine && start === -1) {
      start = i;
    } else if (!isPipeLine) {
      flush(i);
    }
  }
  return tables;
}

export function listBodyTokens(body: string): string[] {
  const tokens: string[] = [];
  for (const match of body.matchAll(TOKEN_PATTERN)) {
    if (match[0].startsWith('!') || match[2] !== undefined) continue;
    const token = match[0];
    if (token === PHOTO_TOKEN || tokens.includes(token)) continue;
    tokens.push(token);
  }
  return tokens;
}
